// extracted by mini-css-extract-plugin
export default {"header":"Table_header__IQ0pW","link":"Table_link__fHZpB","active":"Table_active__hObr7","inactive":"Table_inactive__g8MRr"};